import { render } from "./BzSelect.vue?vue&type=template&id=8e0dd69e&scoped=true"
import script from "./BzSelect.vue?vue&type=script&lang=js"
export * from "./BzSelect.vue?vue&type=script&lang=js"

import "./BzSelect.vue?vue&type=style&index=0&id=8e0dd69e&scoped=true&lang=css"
import "./BzSelect.vue?vue&type=style&index=1&id=8e0dd69e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0dd69e"]])

export default __exports__